import { fetchTopics, fetchTopicDetail } from "../api/demo";
//archive
import { fetchArchiveDetail,fetchArchiveList ,fetchNewArchivePage} from "../api/archive";
//work activity
import {fetchProductionDetail,fetchActivityInfoDetail,fetchActivityList,fetchWorksMeta,fetchNewIndexProductionList,fetchNewProductionPage, fetchIndexRightChoList } from "../api/production";
//user
import { fetchUserDetail } from "../api/userInfo";

// import { fetchWeiboToken } from "../api/util";

//live
import { fetchLiveDetail } from "../api/live";
//model
import { fetchModelDetail,fetchNewIndexMakeList } from "../api/model";
//vidoe
import { fetchVideoDetail } from "../api/video";

//question
import { fetchQuestionDetail ,fetchNewQuestionPage} from "../api/question";

//import { postmultipart, post, form } from "@/utils/request";

//section
import { fetchSectionDetail } from "../api/film";
import { fetchDaVList } from "../api/userInfo";
import { fetchColumnMeta ,fetchColumnTypeMeta} from "../api/column";

import {fetchRankUserList} from "../api/index"

import { fetchNewIndexCourseList} from "../api/course";
//服务器渲染获取数据
export default {
  //大v栏目列表
  FETCH_DAV_LIST: ({ commit }, {  cookies }) => {
    return fetchDaVList({ cookies }).then(res =>
        commit("SET_DAV_LIST", { detail: res.data.response })
    );
  },
  //主题
  FETCH_COLUMN_META: ({ commit }, { id, cookies }) => {
    return fetchColumnMeta({id,  cookies }).then(res =>
        commit("SET_COLUMN_META", { detail: res.data.response })
    );
  },
  FETCH_COLUMN_TYPE_META: ({ commit }, { id, cookies }) => {
    return fetchColumnTypeMeta({id,  cookies }).then(res =>
        commit("SET_COLUMN_TYPE_META", { detail: res.data.response })
    );
  },
  //dav文章列表
  FETCH_ARCHIVE_LIST: ({ commit }, { creatorId, cookies }) => {
    return fetchArchiveList({ creatorId, cookies }).then(res =>
        commit("SET_ARCHIVE_LIST", { detail: res.data.response })
    );
  },
  //文章详情
  FETCH_ARCHIVE_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchArchiveDetail({id,cookies }).then(res =>
      commit("SET_ARCHIVE_DETAIL", { detail: res.data.response })
    );
  },
  //作品详情
  FETCH_PRODUCTION_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchProductionDetail({ id, cookies }).then(res =>
      commit("SET_PRODUCTION_DETAIL", { detail: res.data.response })
    );
  },
  //作品列表
  FETCH_WORKS_META: ({ commit }, { id, cookies }) => {
    return fetchWorksMeta({ id, cookies }).then(res =>
        commit("SET_WORKS_META", { detail: res.data.response })
    );
  },

  FETCH_WORKS_LIST: ({ commit, state }, { cookies }) => {
    return state.worksList
        ? Promise.resolve()
        : fetchWorks({ cookies }).then(res =>
            commit("SET_WORKS_LIST", { list: res.data.data })
        );
  },
  //作品活动征集详情页面
  FETCH_ACTIVITY_INFO_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchActivityInfoDetail({ id, cookies }).then(res =>
      commit("SET_ACTIVITY_INFO_DETAIL", { detail: res.data.response })
    );
  },
  FETCH_ACTIVITY_LIST: ({ commit }, { activityType, cookies }) => {
    return fetchActivityList({ activityType, cookies }).then(res =>
        commit("SET_ACTIVITY_LIST", { detail: res.data.response })
    );
  },
  //个人主页
  FETCH_USER_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchUserDetail({ id, cookies }).then(res =>{
      commit("SET_USER_DETAIL", { detail: res.data.response })
    }
    );
  },

  // //微博Tokken
  // FETCH_WEIBO_TOKEN: ({ commit }, { code, cookies }) => {
  //   return fetchWeiboToken({ code, cookies }).then(res =>
  //
  //       // console.log("res====================",res)
  //       commit("SET_WEIBO_TOKEN", { weibotoken: res.data.response })
  //   );
  // },

  //点播
  FETCH_VIDEO_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchVideoDetail({ id, cookies }).then(res =>
        commit("SET_VIDEO_DETAIL", { detail: res.data.response })
    );
  },
  //直播
  FETCH_LIVE_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchLiveDetail({ id, cookies }).then(res =>
        commit("SET_LIVE_DETAIL", { detail: res.data.response })
    );
  },
  FETCH_MODEL_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchModelDetail({ id, cookies }).then(res =>
        commit("SET_MODEL_DETAIL", { detail: res.data.response })
    );
  },
  FETCH_QUESTION_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchQuestionDetail({ id, cookies }).then(res =>
        commit("SET_QUESTION_DETAIL", { detail: res.data.response })
    );
  },

  //放映厅剧集---课节
  FETCH_SECTION_DETAIL: ({ commit, state  }, { id, cookies ,params}) => {
      console.log("cookies=-====================" ,cookies)
    // return fetchSectionDetail({ id, cookies }).then(res =>{
    //         //console.log(" res.data.response-------", res.data.response)
    //       commit("SET_SECTION_DETAIL", { detail: res.data.response })
    //     });

      return state.sectionDetail
          ? Promise.resolve()
          : fetchSectionDetail({ id, cookies,params }).then(res =>{
              commit("SET_SECTION_DETAIL", { detail: res.data.response })
          });
  },
  //demo 方法 start------------
  FETCH_TOPICS_LIST: ({ commit, state }, { cookies }) => {
    return state.topicsList
      ? Promise.resolve()
      : fetchTopics({ cookies }).then(res =>
          commit("SET_TOPICS_LIST", { list: res.data.data })
        );
  },
  FETCH_TOPIC_DETAIL: ({ commit }, { id, cookies }) => {
    return fetchTopicDetail({ id, cookies }).then(res =>
      commit("SET_TOPIC_DETAIL", { detail: res.data.data })
    );
  },
  //demo方法 end =========================

  /**
   * 新版
   */

  //动画短片
  FETCH_NEW_INDEX_PRODUCTION_LIST: ({ commit ,state}, { id, cookies,params }) => {
    return state.productionList
        ? Promise.resolve()
        : fetchNewIndexProductionList({ id, cookies,params }).then(res =>{
      if(res.status == 200){
        commit("SET_NEW_INDEX_PRODUCTION_LIST", { list: res.data.list })
      }

    });
  },
  //传统文化 --注：传统文化首页通用方法
  FETCH_NEW_INDEX_STORY_LIST: ({ commit,state }, { id, cookies,params }) => {
    return state.newIndexStoryList
        ? Promise.resolve()
        : fetchNewIndexProductionList({ id, cookies,params }).then(res =>{
      if(res.status == 200){
        commit("SET_NEW_INDEX_STORY_LIST", { list: res.data.list })
      }

    });
  },
  //动画制作 --注：课程列表页通用方法
  FETCH_NEW_INDEX_COURSE_LIST: ({ commit,state }, { id, cookies,params }) => {
    return state.newIndexCourseList
        ? Promise.resolve()
        : fetchNewIndexCourseList({ id, cookies,params }).then(res =>{
      if(res.status == 200){
        commit("SET_NEW_INDEX_COURSE_LIST", { list: res.data })
      }

    });
  },
  //作品列表
  FETCH_NEW_PRODUCTION_LIST: ({ commit,state }, { id, cookies,params }) => {
    return state.newProductionPage
        ? Promise.resolve()
        : fetchNewProductionPage({ id, cookies,params }).then(res =>{
          if(res.status == 200){
            commit("SET_NEW_PRODUCTION_PAGE", { page: res.data })
          }
        });
  },

  //用户详情
  FETCH_NEW_USER_DETAIL: ({ commit,state }, { id, cookies }) => {
    return state.newUserDetail
        ? Promise.resolve()
        : fetchUserDetail({ id, cookies }).then(res =>{
          console.log("=============================res======",res.data.code)
          if(res.data.code == 1){
            commit("SET_NEW_USER_DETAIL", { details: res.data.response })
          }
        });
  },

  FETCH_RANK_USER_LIST: ({ commit ,state}, { id, cookies,params }) => {
    return state.rankUserList
        ? Promise.resolve()
        : fetchRankUserList({ id, cookies,params }).then(res =>{
          if(res.data.code == 1){
            commit("SET_RANK_USER_LIST", { list: res.data.response })
          }

        });
  },


  //动画短片--经典获奖
  FETCH_NEW_INDEX_VIDEO_PRODUCTION_ONE_LIST: ({ commit ,state}, { id, cookies,params }) => {
    return state.newIndexVideoProductionOneList
        ? Promise.resolve()
        : fetchNewIndexProductionList({ id, cookies,params }).then(res =>{
          if(res.status == 200){
            commit("SET_NEW_INDEX_VIDEO_PRODUCTION_ONE_LIST", { list: res.data.list })
          }

        });
  },
  //动画短片--国内优秀
  FETCH_NEW_INDEX_VIDEO_PRODUCTION_TWO_LIST: ({ commit,state }, { id, cookies,params }) => {
    return state.newIndexVideoProductionTwoList
        ? Promise.resolve()
        : fetchNewIndexProductionList({ id, cookies,params }).then(res =>{
          if(res.status == 200){
            commit("SET_NEW_INDEX_VIDEO_PRODUCTION_TWO_LIST", { list: res.data.list })
          }

        });
  },
  //动画短片--传统文化
  FETCH_NEW_INDEX_VIDEO_PRODUCTION_THREE_LIST: ({ commit,state }, { id, cookies,params }) => {
    return state.newIndexVideoProductionThreeList
        ? Promise.resolve()
        : fetchNewIndexProductionList({ id, cookies,params }).then(res =>{
          if(res.status == 200){
            commit("SET_NEW_INDEX_VIDEO_PRODUCTION_THREE_LIST", { list: res.data.list })
          }
        });
  },


  //动画制作--作品
  FETCH_NEW_INDEX_MAKE_PRODUCTION_LIST: ({ commit,state }, { id, cookies,params }) => {
    return state.newIndexMakeProductionList
        ? Promise.resolve()
        : fetchNewProductionPage({ id, cookies,params }).then(res =>{
          if(res.status == 200){
            commit("SET_NEW_INDEX_MAKE_PRODUCTION_LIST", { list: res.data.list })
          }
        });
  },

  //动画制作--素材
  FETCH_NEW_INDEX_MAKE_MODEL_LIST: ({ commit,state }, { id, cookies,params }) => {
    return state.newIndexMakeModelList
        ? Promise.resolve()
        : fetchNewIndexMakeList({ id, cookies,params }).then(res =>{
          if(res.data.code == 1){
            commit("SET_NEW_INDEX_MAKE_MODEL_LIST", { list: res.data.response.list })
          }
        });
  },

  //动画制作--右侧精选
  FETCH_INDEX_RIGHT_CHO_LIST: ({ commit,state }, { id, cookies,params }) => {
    return fetchIndexRightChoList({ id, cookies,params }).then(res =>{
          if(res.data.code == 1){
            commit("SET_INDEX_RIGHT_CHO_LIST", { list: res.data.response.list })
          }
        });
  },

  //动画制作-文章
  FETCH_NEW_ARCHIVE_PAGE: ({ commit,state }, { id, cookies,params }) => {
    return state.newArchivePage
        ? Promise.resolve()
        :fetchNewArchivePage({ id, cookies,params }).then(res =>{
          console.log("-----------------",res)
      if(res.status == 200){
        commit("SET_NEW_ARCHIVE_PAGE", { page: res.data })
      }
    });
  },
  //动画制作-问答
  FETCH_NEW_QUESTION_PAGE: ({ commit,state }, { id, cookies,params }) => {
    return state.newQuestionPage
        ? Promise.resolve()
        :fetchNewQuestionPage({ id, cookies,params }).then(res =>{
          if(res.status == 200){
            commit("SET_NEW_QUESTION_PAGE", { page: res.data })
          }
        });
  },


    //动画制作--素材
    FETCH_NEW_MODEL_PAGE: ({ commit,state }, { id, cookies,params }) => {
        return state.newModelPage
            ? Promise.resolve()
            : fetchNewIndexMakeList({ id, cookies,params }).then(res =>{
                if(res.data.code == 1){
                    commit("SET_NEW_MODEL_PAGE", { page: res.data.response })
                }
            });
    },

};
